<template>
  <PageSection
    disable-sticky-margin
    :title="$t('enums.notification_settings.' + index)"
  >
    <div class="grid-form">
      <template v-for="(item, itemIndex) in setting" :key="itemIndex">
        <div
          v-if="
            !item['visible'] ||
            notificationSettings[Object.keys(item['visible'])[0]] ==
              Object.values(item['visible'])[0]
          "
          :class="item.class"
        >
          <DynamicFormInput
            :question="item"
            :questionIndex="itemIndex"
            :vertical_align="false"
            :defaultValue="notificationSettings[item.name]"
            :isDefaultValue="true"
            @questionValue="getQuestionValue"
          />
        </div>
      </template>
    </div>
  </PageSection>
</template>
<script>
import { mapMutations } from 'vuex'

// import DynamicFormInput from "../../../../../baseComponents/form/DynamicFormInput"

export default {
  name: 'SingleNotificationSettingComponent',
  // components: {DynamicFormInput},
  props: {
    setting: {
      type: Object,
      required: true
    },
    index: {
      type: String,
      required: true
    },
    notificationSettings: {
      type: Object,
      required: true
    }
  },
  methods: {
    ...mapMutations({
      alterNotificationSettings:
        'notificationSettings/alterNotificationSettings'
    }),
    getQuestionValue({ attribute, value }) {
      this.alterNotificationSettings({
        notificationSettings: this.notificationSettings,
        attribute: attribute,
        value: value
      })
    }
  }
}
</script>
